// react core
import React, {useContext}  from 'react';
import Select from 'react-select'
import { useNavigate } from 'react-router-dom';

// state
import { StateContext } from 'store/state_context';

// utils
import {
    tags_transformer,
    add_params_to_uri,
    find_select_label_by_id,
    react_select_add_value_field
} from 'commons/utils';

export default function SubTitle(props)
{
    const navigate = useNavigate();

    // array data for selects
    const tag_list = tags_transformer.get_options_from_tags(props.tags);
    const sort_by_items = props.sort_by_items.data || [];
    const questions_items = props.questions_items.data || [];

    let tag_label = (props.current_tag === '') ? 'All' : find_select_label_by_id(props.current_tag, tag_list);
    let order_by_label = (props.current_order_by === '') ? 'All' : find_select_label_by_id(props.current_order_by, questions_items);
    let sort_by_label = (props.current_sort_by === '') ? 'All' : find_select_label_by_id(props.current_sort_by, sort_by_items);

    const { total_questions } = useContext(StateContext);

    const QuestionLabel = (props) =>
    {
        const total_questions = parseInt(props.total_questions, 10);
        if(total_questions !== null && (typeof total_questions !== 'undefined') && total_questions > 0)
        {
            return <div>{total_questions} questions</div>
        }
        else
        {
            return <div>0 questions</div>
        }
    };

    const on_change_tag = (item) =>
    {
        const data = add_params_to_uri({
            filters: {
                tag: item.id
            }
        });
        navigate(data.url);
    };

    const on_change_sort_by = (item) =>
    {
        const data = add_params_to_uri({
            filters: {
                sort_by: item.id
            }
        });
        navigate(data.url);
    };

    const on_change_status = (item) =>
    {
        const data = add_params_to_uri({
            filters: {
                order_by: item.id
            }
        });
        navigate(data.url);
    };

    return (
        <>
            <div id="filters-selection">
                <QuestionLabel total_questions={total_questions}/>
                <div>
                    <label htmlFor="filters-selection-tag">Tag:</label>
                    <Select
                        id="filters-selection-tag"
                        options={tag_list}
                        className="basic-multi-select"
                        classNamePrefix="select"
                        placeholder={tag_label}
                        value={tag_label}
                        onChange={on_change_tag}
                    />
                </div>
                <div>
                    <label htmlFor="filters-selection-status">Status:</label>
                    <Select
                        id="filters-selection-status"
                        options={react_select_add_value_field(questions_items)}
                        className="basic-multi-select"
                        classNamePrefix="select"
                        placeholder={order_by_label}
                        value={order_by_label}
                        onChange={on_change_status}
                    />
                </div>
                <div>
                    <label htmlFor="filters-selection-sort">Sort on:</label>
                    <Select
                        id="filters-selection-sort"
                        options={react_select_add_value_field(sort_by_items)}
                        className="basic-multi-select"
                        classNamePrefix="select"
                        placeholder={sort_by_label}
                        value={sort_by_label}
                        onChange={on_change_sort_by}
                    />
                </div>
            </div>
        </>
    )
}

SubTitle.defaultProps = {
    tags: [],
    sort_by_items: [],
    questions_items: []
};